import mapConfig from "../lib/mapConfig";
import Search from "@arcgis/core/widgets/Search";
import LocatorSearchSource from "@arcgis/core/widgets/Search/LocatorSearchSource";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";

const buildSearchSource = (sourceConfig: any) => {
  const symb = new SimpleMarkerSymbol(mapConfig.searchSymbolProperties);
  return new LocatorSearchSource({
    resultSymbol: symb,
    ...sourceConfig,
  });
};

const buildSearchSources = (sourcesConfig: any[]) => {
  return sourcesConfig.map((x) => buildSearchSource(x));
};

export const buildSearch = (containerId: string, view?: any) => {
  const options = {
    container: containerId,
    sources: buildSearchSources(mapConfig.searchSources),
    ...mapConfig.searchConfig,
  };
  if (view) options.view = view;
  return new Search(options);
};
